import { Box, Theme, useMediaQuery } from '@mui/material';
import LoginForm from 'components/features/LoginForm';
import Footer from 'components/Footer';
import { LoginFormProvider } from 'components/providers/LoginFormProvider';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const LoginPage = () => {
  const isSp = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.has('accessToken')) {
      const token = searchParams.get('accessToken');
      if (token) {
        searchParams.delete('accessToken');
        setSearchParams(searchParams);
      }
    }
  }, []);

  return (
    <main style={{ backgroundColor: 'lightgray' }}>
      <section>
        <Box
          sx={{
            width: '100%',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              border: '1px solid #000000',
              height: '350px',
              width: '350px',
              boxShadow: '0px 4px 10px 0px #00000014',
              maxWidth: '80%',
              borderRadius: '10px',
              padding: isSp ? '20px' : '40px',
              backgroundColor: 'white',
            }}
          >
            <LoginFormProvider>
              <LoginForm />
            </LoginFormProvider>
          </Box>
        </Box>
        <span
          style={{
            position: 'relative',
            bottom: '30px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Footer />
        </span>
      </section>
    </main>
  );
};
